// Re-export MeetHourJS from the library lib-meet-hour to (the other features
// of) the project meet-hour.
import MeetHourJS from './_';
export { MeetHourJS as default };

// XXX Re-export the properties exported by MeetHourJS in order to prevent
// undefined imported MeetHourJS. It may be caused by import cycles but I have
// not confirmed the theory.
export const analytics = MeetHourJS.analytics;
export const browser = MeetHourJS.util.browser;
export const MHConferenceErrors = MeetHourJS.errors.conference;
export const MHConferenceEvents = MeetHourJS.events.conference;
export const MHConnectionErrors = MeetHourJS.errors.connection;
export const MHConnectionEvents = MeetHourJS.events.connection;
export const MHConnectionQualityEvents
    = MeetHourJS.events.connectionQuality;
export const MHDetectionEvents = MeetHourJS.events.detection;
export const MHE2ePingEvents = MeetHourJS.events.e2eping;
export const MHMediaDevicesEvents = MeetHourJS.events.mediaDevices;
export const MHParticipantConnectionStatus
    = MeetHourJS.constants.participantConnectionStatus;
export const MHRecordingConstants = MeetHourJS.constants.recording;
export const MHSIPVideoGWStatus = MeetHourJS.constants.sipVideoGW;
export const MHTrackErrors = MeetHourJS.errors.track;
export const MHTrackEvents = MeetHourJS.events.track;
export const MHTrackStreamingStatus = MeetHourJS.constants.trackStreamingStatus;

export * from './actions';
export * from './actionTypes';
export * from './functions';
